export default "__VITE_ASSET__CW3ZIhip__"